/* ============================================================================================== */
/* ====================================== GRAPHQL mutation ====================================== */
/* ============================================================================================== */

export const mutateGraphQL = async (props) => {
	const { mutationData, mutateFunction, mutationInputFunction, mutationInputFunction2, mutationData2, mutationOutputFunction } = props
	// console.log({
	// 	queryVariables: {
	// 		[mutationInputFunction]: mutationData,
	// 		...(mutationData2 && { [mutationInputFunction2]: mutationData2 }),
	// 	},
	// })
	const apolloData = await mutateFunction({
		variables: {
			[mutationInputFunction]: mutationData,
			...(mutationData2 && { [mutationInputFunction2]: mutationData2 }),
		},
	})
	// console.log({ queryResult: apolloData?.data?.[mutationOutputFunction] })
	return apolloData?.data?.[mutationOutputFunction]
}
